import { query_arrange_shift_list } from 'liyu-pc-base/api/org-model';

export default () => {
  const search_config: any = {
    model: {
      is_active: true,
      is_type: 10,
      is_me: false,
      pageSize: 100,
    },
    watch: [],
  };
  return {
    getData: query_arrange_shift_list,
    searchConfig: search_config,
  };
};
